import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class SvgSDM17SPTInstall extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg height={(size / 1.5).toString()} width={(size / 1.5).toString()} viewBox="0 0 300 149.5">
                <g fill={color}>
                    <path
                        className="cls-1"
                        d="M285,90.25v119.5H15V90.25H285m5-15H10a10,10,0,0,0-10,10v129.5a10,10,0,0,0,10,10H290a10,10,0,0,0,10-10V85.25a10,10,0,0,0-10-10Z"
                        transform="translate(0 -75.25)"
                    />
                    <path className="cls-1" d="M290,113.75v72.5H10v-72.5H290m10-10H0v92.5H300v-92.5Z" transform="translate(0 -75.25)" />
                    <path className="cls-1" d="M290,128.25v43.5H10v-43.5H290m10-10H0v63.5H300v-63.5Z" transform="translate(0 -75.25)" />
                    <path className="cls-1" d="M213.75,147.25A3.75,3.75,0,1,0,217.5,151a3.75,3.75,0,0,0-3.75-3.75Z" transform="translate(0 -75.25)" />
                    <path className="cls-1" d="M213.75,136.22a1.78,1.78,0,1,0,1.78,1.78,1.78,1.78,0,0,0-1.78-1.78Z" transform="translate(0 -75.25)" />
                </g>
            </svg>
        );
    }
}

export default withTheme(SvgSDM17SPTInstall);



// WEBPACK FOOTER //
// ./data/common/iconsvg/SvgSDM17SPTInstall.js